import React, { Component } from 'react'
import styled from 'styled-components'
import content from '../../../data/indexContent'
import CtaButtonLg from '../UI/CtaButtonLg'
import icons from '../../assets/icons/exports'

class ContentGrid extends Component {
  render() {
    return (
      <ContentGridContainer>
        <div className="features-grid">
          <div className="feature blockOne">
            <img src={icons.mobile_apps} alt="wireframe" />
            <h4>{content.blockOne__Title}</h4>
            <p>{content.blockOne__Description}</p>
          </div>

          <div className="feature blockTwo">
            <img src={icons.brainstorm} alt="wireframe" />
            <h4>{content.blockTwo__Title}</h4>
            <p>{content.blockTwo__Description}</p>
          </div>

          <div className="feature blockThree">
            <img src={icons.security} alt="wireframe" />
            <h4>{content.blockThree__Title}</h4>
            <p>{content.blockThree__Description}</p>
          </div>

          <div className="feature blockFour">
            <img src={icons.low_code} alt="wireframe" />
            <h4>{content.blockFour__Title}</h4>
            <p>{content.blockFour__Description}</p>
          </div>

          <div className="feature blockFive">
            <img src={icons.cross_platform} alt="wireframe" />
            <h4>{content.blockFive__Title}</h4>
            <p>{content.blockFive__Description}</p>
          </div>

          <div className="feature blockSix">
            <img src={icons.testing} alt="wireframe" />
            <h4>{content.blockSix__Title}</h4>
            <p>{content.blockSix__Description}</p>
          </div>
        </div>
        <div className="button-container">
          <CtaButtonLg to={'/contact'}>
            See What AppTree Can Do For You →
          </CtaButtonLg>
        </div>
      </ContentGridContainer>
    )
  }
}

export default ContentGrid

const ContentGridContainer = styled.div`
  text-align: center;
  margin: auto;
  width: 90%;

  @media screen and (max-width: 768px) {
    width: 80%;
    margin: auto;
  }

  .feature {
    color: white;
    width: 300px;
    line-height: 1.5;
    font-weight: 100;

    h4 {
      color: white;
      font-size: 2rem;
      color: #0092cf;
    }

    p {
      color: white;
      line-height: 1.5;
      font-weight: 300;
    }
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    grid-gap: 25px;
    justify-content: center;
  }

  .button-container {
    margin-top: 50px;
  }

  img {
    height: 50px;
    color: green;
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/components/IndexContent/features_grid.jsx